export const endPoints = {
  login: "api/v1/auth/login",
  ssoLogin: "api/v1/oidc/login",
  logout: "api/v1/auth/logout",
  currentUser: "api/v1/users/me",
  getWorkOrderList: "api/v1/workorders/workorder-list-v2?platform=web",
  getWorkOrderListMap: "api/v1/get-map-data",
  getWorkOrderById: "api/v1/workorders/workorder-by-id",
  getWorkOrderByCaseStatus: "api/v1/workorders/workorder-by-case-status",
  getWorkOrderByCaseType: "api/v1/workorders/workorder-by-case-type",
  getWorkOrderListPaged: "api/v1/workorders/workorder-list-paged?platform=web",
  getWorkorderInfo: "api/v1/workorders/workorder-info",
  updateStatus: "api/v1/workorders/update-workorder-status",
  updateApproval: "api/v1/workorders/update-approval",
  getDashboardMetrics: "api/v1/reports/report-dashboard-metrics",
  getGraphData: "api/v1/reports/report-graph-data",
  getTenantUsersList: "api/v1/users/list-tenant-users",
  addTenantUser: "api/v1/users/add-tenant-user",
  deleteTenantUser: "api/v1/users/delete-tenant-user",
  resetUserPassword: "api/v1/users/reset-user-password",
  uploadProjectCaseFile: "api/v1/files/upload-project-case-file",
  appconfig: "api/v1/reports/env-vars",
  assignWorkOrder: "api/v1/workorders/reassign-workorder",
  epsgFormat: "api/v1/gis/generate-gis",
  addlogs: "api/v1/logging/add-logs",
};
